import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LoaderService } from '@app/core/loader/loader.service';
import { catchError, throwError } from 'rxjs';

export const loaderHttpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  return next(req).pipe(
    catchError((error) => {
      loaderService.clearLoadings();
      return throwError(() => error);
    }),
  );
};
